export default "__VITE_ASSET__CIwlM3Lz__"